<template>
  <div class="import-dialog">
    <el-dialog title="数据导入" v-model="dialogVisible" width="500px" @close="handleClose">
      <el-form ref="importFormRef" :model="importForm" label-width="100px">
<!--        <el-form-item label="选择店铺" prop="warehouseId" :rules="{ required: true, message: '请选择店铺', trigger: 'change' }">-->
<!--          <el-select v-model="importForm.shopId" placeholder="请选择店铺" style="width: 100%">-->
<!--            <el-option-->
<!--                v-for="item in shopList"-->
<!--                :key="item.id"-->
<!--                :label="item.shopName"-->
<!--                :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

        <el-form-item label="上传文件" prop="file" :rules="{ required: true, message: '请上传文件', trigger: 'change' }">
          <el-upload
              ref="uploadRef"
              class="upload-demo"
              drag
              :auto-upload="false"
              :on-change="handleFileChange"
              :on-remove="handleFileRemove"
              accept=".xlsx,.xls,.csv">
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <template #tip>
              <div class="el-upload__tip">
                请上传.xls、.xlsx或.csv格式文件，文件大小不超过10MB
              </div>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="submitImport">确定导入</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElDialog, ElForm, ElFormItem, ElUpload, ElButton, ElIcon, ElMessage } from 'element-plus'
import { UploadFilled } from '@element-plus/icons-vue'
import {getBaseShopList,importRemovalShipmentData} from "@/utils/api";

export default {
  name: 'importDialog',
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElUpload,
    ElButton,
    ElIcon,
    UploadFilled
  },
  beforeMount() {
    //this.getBaseShopList()
  },
  data() {
    return {
      dialogVisible: this.visible,
      filterList:[
          "001-SC-KRZN-US美国",
          "018-SC-CSJ-US美国",
          "044-SC-SYLV-US美国",
          "034-WM-KRDZ-US美国",
          "036-WM-KRZN-US美国",
      ],
      importForm: {
        shopId: '',
        file: null
      },
      shopList: [],
    }
  },
  methods: {
    getBaseShopList() {
      getBaseShopList({PageSize:1000}).then(res => {
        this.shopList = res.Data.filter(item =>
            this.filterList.some(filterItem => item.shopName.includes(filterItem))
        )
      })
    },
    open() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    handleFileChange(file) {
      this.importForm.file = file.raw
    },
    handleFileRemove() {
      this.importForm.file = null
    },
    resetForm() {
      this.importForm = {
        shopId: '',
        file: null
      }
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
    },
    submitImport() {
      // 创建 FormData 对象
      const formData = new FormData();
      formData.append('shopId', this.importForm.shopId);
      formData.append('file', this.importForm.file);

      // 使用 FormData 上传
      importRemovalShipmentData(formData).then(res => {
        console.log(res);
        this.$emit('closeEdit');
        this.resetForm();
        this.dialogVisible = false;
        ElMessage.success('导入成功');
      }).catch(err => {
        ElMessage.error(err.message);
      });
    }
  }
}
</script>

<style scoped>
.upload-demo {
  width: 100%;
}

.el-icon--upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 40px 0 16px;
  line-height: 50px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
